import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { investmentSources } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSource/configs'
import { STATUS_OPTIONS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/configs'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'

import { TFormValidationResult } from 'cng-common/features/form/models'
import { isEmpty } from 'cng-common/helpers/validation/isEmpty'
import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'
import { isValidKeyInitiativeFundingAmount } from 'partner360/features/keyInitiativeEditor/lib/keyInitiativeMdfFunding'

import { IKeyInitiativeForm } from '../models/keyInitiativeForm'

interface IValidationParams {
  form: Pick<IKeyInitiativeForm, 'hpInvestmentSum' | 'hpInvestmentSource' | 'status'>
  isInvestmentNeeds: boolean
  isFundingDisabled: boolean
  isStatusDisabled: boolean
  investmentSumRequiredMessage?: string
}

export const validateKeyInitiativeFundingAndStatus = async ({
  form,
  isInvestmentNeeds,
  isFundingDisabled,
  isStatusDisabled,
  investmentSumRequiredMessage = TRANSLATION_KEYS.keyInitiativeEditor.investmentFieldGroup
    .investmentSumPositiveRequired,
}: IValidationParams) => {
  const fundingResults: TFormValidationResult[] = []
  const statusResults: TFormValidationResult[] = []

  if (isInvestmentNeeds && !isFundingDisabled) {
    const amountMessage = isValidKeyInitiativeFundingAmount(form.hpInvestmentSum)
      ? ''
      : investmentSumRequiredMessage
    const sourceMessage =
      isEmpty(form.hpInvestmentSource) ||
      (await ValidationHelper.checkDropdown(
        form.hpInvestmentSource ?? '',
        investmentSources,
        'value'
      ))

    if (amountMessage) {
      fundingResults.push({ field: 'hpInvestmentSum', message: amountMessage })
    }
    if (sourceMessage) {
      fundingResults.push({ field: 'hpInvestmentSource', message: sourceMessage })
    }
  }

  if (!isStatusDisabled) {
    const statusMessage =
      isEmpty(form.status) ||
      (await ValidationHelper.checkDropdown(
        normalizeKeyInitiativeStatus(form.status),
        STATUS_OPTIONS,
        'key'
      ))

    if (statusMessage) {
      statusResults.push({ field: 'status', message: statusMessage })
    }
  }

  return { fundingResults, statusResults }
}
